import { matchPath } from "react-router";

/** Top-level header entries a page can light up. */
export type HeaderSection =
  | "/"
  | "/mi-jornada"
  | "/clientes"
  | "/contacts"
  | "/whatsapp"
  | "/operaciones"
  | "/dinero"
  | "marketing";

const SECTIONS: { section: HeaderSection; patterns: string[] }[] = [
  { section: "/", patterns: ["/"] },
  { section: "/mi-jornada", patterns: ["/mi-jornada"] },
  { section: "/clientes", patterns: ["/clientes/*"] },
  { section: "/contacts", patterns: ["/contacts/*"] },
  { section: "/whatsapp", patterns: ["/whatsapp/*"] },
  {
    section: "/operaciones",
    patterns: ["/operaciones/*", "/instaladores/*"],
  },
  { section: "/dinero", patterns: ["/dinero/*", "/setters"] },
  {
    section: "marketing",
    patterns: [
      "/correo/*",
      "/web/*",
      "/rendimiento",
      "/reactivacion",
      "/parte",
    ],
  },
];

/** Which header entry is active for a pathname, or null for none. */
export const activeSection = (pathname: string): HeaderSection | null =>
  SECTIONS.find(({ patterns }) =>
    patterns.some((pattern) => matchPath(pattern, pathname)),
  )?.section ?? null;
